import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/requestaccess.module.css'

export default function requestaccess() {
    return (
        <section>
            <Layout>
                <div className={styles.row}>
                    <div class={styles.side}>
                        <h2>Contact Information</h2>
                        <h5>Complete the form and hit submit</h5>
                        <h3>+353 6789754</h3>
                        <h3>info@visiotherapy.com</h3>
                        <h3>Dublin, <br></br>Ireland</h3>   
                    </div>
                    <div className={styles.main}>
                        <h4>👋Hello there, what is your name?*</h4>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <h4>What's your email address?*</h4>
                        <h5>👇🏼We need to add you to our waitlist</h5>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <h4>Why are you interested in our products?</h4>
                        <h5>🤝Tell us more about how we can help you</h5>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <h4>👨‍🎓What is your current Position?</h4>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <h4>How did you hear about VisioTherapy?</h4>
                        <h5>Tell us more about how you came to hear about us</h5>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <h4>Message</h4>
                        <h6>Type your answer here...</h6>
                        <br></br>
                        <button className={styles.button}>Submit</button>
                    </div>
                </div>
            </Layout>
        </section>
    )
}
